import React, {useRef , useEffect, useState} from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import UseStyles from "../../../useStyles";
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';

import { useSnackbar } from 'notistack';

import PautaIcon from "../../../../../images/icons/ata-icon.svg";
import DocumentIcons from "../../../../../images/icons/document-icon.svg";
import DocBtn from "../../../../documento/botaoDownload";

import {getAtaByIdReuniao, getById} from '../../../../../services/reuniao/ReuniaoService';

import { download } from '../../../../../services/documento/DocumentoService';

const AbaPautaVisualizar = (props) => {

  const classes = UseStyles();

  // const {
  //   expediente,
  //   ordem,
  //   comunicacoes,
  //   outros,
  //   pauta,
  //   pautaExtra
  // } = props.dados;

  const id  = props.id;
  
  const pautaRef = useRef(null);

  const { enqueueSnackbar } = useSnackbar();

  const [reuniao, setReuniao] = useState({});

  const downloadAta = async () => {
    if(reuniao.ata && reuniao.ata.id) {
      try {
        const response = await download(reuniao.ata.id);
        const url = URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement('a');
        a.href = url;
        document.body.appendChild(a);
        a.download = `${reuniao.ata.nome}.${reuniao.ata.formato}`;
        a.click();
      } catch (e) {
        enqueueSnackbar('Ocorreu um erro ao realizar o download da ata', { variant: 'error' })
      }
    }    
  }

  const getAta = async (data) => {
    const response = await getAtaByIdReuniao(id);
    console.log(data)
    setReuniao({ ...data, ata: response.data});
  }

  useEffect(() => {
    getById(id).then((response) => {
      if (response && response.status === 200) {
        const { data } = response;
        setReuniao(data)
        getAta(data);
        // setMostarEditarPerfil(roles[0] === 'ROLE_EQUIPE_TECNICA' || keycloak.tokenParsed.sub === data.sub);
      }
    })
  }, [])

  return (
    <>
      <Grid alignItems="stretch" container spacing={2}>
        <Grid item md={6} sm={12}>
          <Typography className={classes.tituloAba}>Pauta</Typography>
          <div style={{ marginTop: 24, padding: 24, backgroundColor: '#fff', border: 'solid 1px #dfdfe6', borderRadius: 4 }}>
            <div dangerouslySetInnerHTML={{__html: reuniao.pauta}}>
            </div>
          </div>
        </Grid>
        <Grid item md={6} sm={12}>
          <Typography className={classes.tituloAba}>Ata</Typography>
          {(reuniao.ata === null || reuniao.ata === '') ? <>
            <div style={{ borderRadius: 4, border: '1px solid #c2c4d1', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', marginTop: 24, padding: 24, cursor: 'not-allowed' }}>
              <img src={PautaIcon} />
              <Typography style={{ color: '#5e6784', fontSize: 16, width: '100%', maxWidth: 350, marginTop: 24, textAlign: 'center' }}>A ata estará disponível após a realização da reunião</Typography>
            </div>
          </> : <>
              {reuniao.ata &&
                <div style={{ marginTop: 24, position: 'relative' }}>
                  <DocBtn large onClickHandle={downloadAta}>
                    <Typography>Download da ata</Typography>
                  </DocBtn>
                  {/* <div style={{ position: 'absolute', top: 5, right: 5 }}>
                    <Button >
                      <DeleteIcon />
                    </Button>
                  </div> */}
                </div>}
            </>}
        </Grid>
        {reuniao.pautaExtra && <Grid item md={6} sm={12}>
          <Typography className={classes.tituloAba}>Extra pauta</Typography>
          <div style={{ marginTop: 24, padding: 24, backgroundColor: '#fff', border: 'solid 1px #dfdfe6', borderRadius: 4 }}>
            <div dangerouslySetInnerHTML={{__html: reuniao.pautaExtra}}>
            </div>
          </div>
        </Grid>}
      </Grid>
    </>
  );
}

export default AbaPautaVisualizar;
